import { render, staticRenderFns } from "./TraxSettingTaskCrudDelete.vue?vue&type=template&id=0962633f"
import script from "./TraxSettingTaskCrudDelete.vue?vue&type=script&lang=js"
export * from "./TraxSettingTaskCrudDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports